{
  "title": "Analyse performance environnementale",
  "subtitle": "Impact évité par vos réparations, réemplois et recyclages, calculé sur le référentiel ACV.",
  "actions": {
    "downloadReport": "Télécharger le rapport"
  },
  "filters": {
    "manufacturer": "Fabricant"
  },
  "sheet": {
    "title": "Rapport de votre performance environnementale",
    "description": "Parce qu’évaluer la valeur d’un produit ne peut pas se faire seul, nous avons réuni 5 entreprises pour co-construire un calculateur basé sur l’expérience terrain. Ensemble, nous avons défini un référentiel marché juste, aligné avec les réalités opérationnelles. Ce référentiel, vivant et évolutif, s’enrichit au fil du temps pour garantir des estimations toujours plus fines et adaptées aux enjeux du recyclage et de la reprise.",
    "sources": "Retrouvez toutes nos sources :",
    "calculationReference": "Référentiel de calcul",
    "ademeSources": "Sources ADEME",
    "calculatorMethodology": "Notes Méthodologique de calculateur",
    "lcaMethodology": "Notes Méthodologique des ACV"
  },
  "cards": {
    "worldTour": "Tours du monde évités",
    "co2": "CO2 évités",
    "materials": "Matières premières non extraites"
  },
  "table": {
    "currentYear": "Nb de dossiers (année en cours)",
    "lastYear": "Année précédente",
    "twoYearsAgo": "Il y a 2 ans",
    "impactMaterial": "Impact matière (kg) (année n-1)",
    "impactCo2": "Impact CO2 (kg) (année n-1)",
    "repair": "Réparation",
    "repairEcosystem": "Calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
    "repairProxy": "Étudiés par Proxi ACV Ademe + Autres sources",
    "repairWithout": "Sans étude préalable",
    "reuse": "Réemploi",
    "reuseEcosystem": "Calculés et référencés via ACV ECOSYSTEM - BOOMERANG",
    "reuseProxy": "Étudiés par Proxi ACV Ademe + Autres sources",
    "reuseWithout": "Sans étude préalable",
    "recycled": "Recyclage",
    "recycledByBoomerang": "Via BOOMERANG",
    "recycledByRepairer": "Autres",
    "rental": "Location",
    "withoutInformation": "Sans information",
    "total": "Total"
  }
}
